export default __webpack_public_path__ + "static/media/0001.410d7882.png";